import {useStyles} from './Button.styles';
import {FunctionComponent, PropsWithChildren} from "react";

type Props = {
    onClick: () => void
    variant?: "primary" | "secondary" | "outline" | "text" | "error"
    className?: string
}

const Button: FunctionComponent<PropsWithChildren<Props>> = (
    {
        children,
        variant = "primary",
        onClick,
        className = ""
    }
) => {
    const styles = useStyles();
    return (
        <button
            className={`${styles[variant]} ${className}`}
            onClick={onClick}
        >
            {children}
        </button>
    )
}

export default Button